import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './i18nResources';
import { DEFAULT_LNG } from './types';

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LNG,
  fallbackLng: DEFAULT_LNG,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
